import React from 'react';
import { Card } from 'react-bootstrap';
import PageHeader from 'components/common/PageHeader';
import {Link} from 'react-router-dom'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const Scheda01 = () => {

  return (<>
    <PageHeader
    title="Scheda 01"
    description="CRITERI PROPOSTA BASE STAKEHOLDER INTEGRATA CON LE NORME CSRD"
    className="mb-3"
    >
    </PageHeader>
    
    <Card style={{marginTop:"2%", marginBottom:"2%"}}>
        <Card.Body>
          <Card.Text>
          <p><strong>La selezione della proposta base degli STAKEHOLDER secondo il metodo CSVC viene effettuata nei confronti di quelli possibili della norma ESRS/GUIDA EFRAG come segue:</strong></p>
<ul>
<li><strong>stakeholder che sono interessati all’andamento finanziario e generale dell’azienda</strong>, corrispondenti ai PORTATORI DI INTERESSE FRUITORI DELL’INFORMATIVA FINANZIARIA (n. 10): Investitori finanziari, Creditori finanziari, Partner commerciali, Sindacati, Parti sociali, Società civile, ONG, Pubbliche Amministrazioni, Analisti e rappresentanti del mondo accademico</li><br />
<li><strong>stakeholder che partecipano in modo specifico alla attività dell’azienda</strong>, corrispondenti ai PORTATORI DI INTERESSE COINVOLTI ED A QUELLI COMUNI in quanto influenzati lungo la catena del valore (n. 7): Dipendenti e altri lavoratori, Fornitori, Consumatoti/Clienti/Utilizzatori finali, Comunità locali, Persone in situazione di vulnerabilità, Autorità pubbliche (comprese autorità di normazione e di vigilanza), Banche centrali</li>
</ul> 
<p><strong>Per la selezione degli STAKEHOLDER della PROPOSTA BASE della CSVC si ritiene opportuno:</strong></p>

<ul>
<li><strong>Raggruppare</strong> I PORTATORI DI INTERESSE <strong>UTILIZZATORI</strong> DELL’INFORMATIVA FINANZIARIA E GENERALE in un unico stakeholder <strong>FRUITORI</strong> che li rappresenti</li><br />
<li><strong>Mantenere la distinzione dei singoli stakeholder PORTATORI DI INTERESSE COMUNI</strong> CHE CORRISPONDONO A PORTATORI DI INTERESSE SPECIFICI, assumendo che siano comprensivi di quelli COINVOLTI e considerando che i Clienti comprendano i Consumatori e la Comunità comprenda le Comunità locali, le Persone delle categorie vulnerabili, le Autorità pubbliche di vigilanza.</li>
</ul>
<p>Di conseguenza la PROPOSTA BASE degli stakeholder secondo il metodo CSCV è la seguente:</p>

<ul>
<li><strong>STAKEHOLDER UTILIZZATORI:</strong></li>
  <ul>
  <li>FRUITORI</li>
  </ul><br />
  <li><strong>STAKEHOLDER COMUNI:</strong></li>
  <ul>
  <li>DIPENDENTI</li>
  <li>FORNITORI</li>
  <li>CLIENTI</li>
  <li>COMUNITÀ</li>
  </ul>




</ul>
          </Card.Text>
          <Card.Footer>
              <Link to="/app/metodologia/fase-a">
                <FontAwesomeIcon icon="chevron-left" className="ms-1 fs-11" />&nbsp;&nbsp;&nbsp;
                Torna all'elenco delle schede della fase A EFRAG 
              </Link>
           </Card.Footer>
        </Card.Body>
      </Card>

    </>)
};

export default Scheda01;
